import { render, staticRenderFns } from "./Taobao-channel.vue?vue&type=template&id=04a557f5&"
import script from "./Taobao-channel.vue?vue&type=script&lang=js&"
export * from "./Taobao-channel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports